import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {BranchModel} from '@core/api/models/branch.model';
import { HydraCollection } from '../hydra/hydra-collection';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BranchApiService extends ApiService {
  readonly resourcePath = 'branches';

  get(id: string): Observable<BranchModel> {
    return this.restRead<BranchModel>(id);
  }

  getByVanityUrl(vanityUrl: string):Observable<HydraCollection<BranchModel>> {
    return this.http.get<HydraCollection<BranchModel>>(this.resourceUrl +"?vanityUrl=" + vanityUrl).pipe(
      map(response => new HydraCollection<BranchModel>(response))
    );
  }

  autoDetect():Observable<HydraCollection<BranchModel>> {
    const ref = new URL(document.referrer).hostname;

    let url = ref.split('.').slice(1).join('.');
    return this.http.get<HydraCollection<BranchModel>>(this.resourceUrl +"?referer=" + url).pipe(
      map(response => new HydraCollection<BranchModel>(response))
    );
  }
}
